import { render, staticRenderFns } from "./downloadInvoicesForm.vue?vue&type=template&id=6809062c"
import script from "./downloadInvoicesForm.vue?vue&type=script&lang=js"
export * from "./downloadInvoicesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports